import Service from '@/service'
export default {
    data () {
        return {
            msg_box: {},
            show_comment_tip: false
        }
    },
    methods: {
        hideCommentTip () {
            this.show_comment_tip = false
        },
        goAddComment (building_id, parent_comment_id = '') {
            return Service.newBuildingComment(building_id, {
                parent_comment_id
            }).then(({ msg_box }) => {
                this.msg_box = msg_box
                this.show_comment_tip = !msg_box.allow
                return msg_box.allow
            })
        }
    }
}
